import { gql } from 'urql';

const HasPlaidMarketingConsent = gql`
  query HasPlaidMarketingConsent {
    hasPlaidMarketingConsent
  }
`;

export default HasPlaidMarketingConsent;
